import React, { useState, useEffect } from 'react';
import { Outlet, Link, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { HiMenu, HiX } from 'react-icons/hi';
import { IoRadioButtonOn } from 'react-icons/io5';
import './NCLayout.css';

function CrestLogo() {
  return (
    <img
      src={`${process.env.PUBLIC_URL}/nudgee-college-crest.png`}
      alt="Nudgee College"
      className="nc-layout-crest"
    />
  );
}

export default function Layout({ config }) {
  const { isAuthenticated, isAdmin, signOut, user } = useAuth();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const [liveCount, setLiveCount] = useState(0);
  const [liveGames, setLiveGames] = useState([]);

  useEffect(() => {
    if (!config?.apiUrl) return;
    const fetchLive = async () => {
      try {
        const res = await fetch(`${config.apiUrl}/games`);
        const data = await res.json();
        const live = (data.data?.games || []).filter(g => g.status === 'live');
        setLiveGames(live);
        setLiveCount(live.length);
      } catch (e) {}
    };
    fetchLive();
    const interval = setInterval(fetchLive, 30000);
    return () => clearInterval(interval);
  }, [config]);

  useEffect(() => { setMenuOpen(false); }, [location.pathname]);

  const hasTicker = liveCount > 0;

  return (
    <div className="nc-layout">
      {hasTicker && (
        <div className="nc-layout-ticker">
          <div className="nc-layout-ticker-track">
            {[...liveGames, ...liveGames, ...liveGames].map((g, i) => (
              <span key={i} className="nc-layout-ticker-item">
                <IoRadioButtonOn className="nc-layout-ticker-dot" />
                LIVE: {g.homeTeam} vs {g.awayTeam} — {g.venue}
              </span>
            ))}
          </div>
        </div>
      )}

      <header className={`nc-layout-header ${hasTicker ? '' : 'no-ticker'}`}>
        <div className="nc-layout-header-inner">
          <Link to="/" className="nc-layout-brand">
            <CrestLogo />
            <div className="nc-layout-brand-text">
              <span className="nc-layout-brand-name">NC LIVE</span>
              <span className="nc-layout-brand-sub">Nudgee College Live Sports</span>
            </div>
          </Link>

          <nav className={`nc-layout-nav ${menuOpen ? 'open' : ''}`}>
            <Link to="/">Home</Link>
            <Link to="/replays">Replays</Link>
            {isAuthenticated && <Link to="/my-streams">My Streams</Link>}
            {isAuthenticated && isAdmin() && <Link to="/admin">Admin</Link>}
            {isAuthenticated
              ? <>
                  <span className="nc-layout-nav-user">{user?.given_name}</span>
                  <button onClick={signOut} className="nc-layout-nav-cta">Sign Out</button>
                </>
              : <Link to="/login" className="nc-layout-nav-cta">Sign In</Link>
            }
          </nav>

          <button className="nc-layout-burger" onClick={() => setMenuOpen(!menuOpen)} aria-label="Menu">
            {menuOpen ? <HiX /> : <HiMenu />}
          </button>
        </div>
      </header>

      <main className="nc-layout-main">
        <Outlet />
      </main>
    </div>
  );
}
